import { clearSession, getToken } from "./session";

// const BASE = "http://localhost:4950";
const BASE = "https://backend.finitygrowth.com";

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.message || "Request failed");
    this.status = status;
    this.errors = body?.errors || null;
  }
}

export function imageUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//.test(path)) return path;
  return `${BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export function money(amount, currency) {
  const value = Number(amount);
  const text = Number.isFinite(value) ? value.toFixed(2) : "0.00";
  return currency ? `${text} ${currency}` : text;
}

export function when(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString();
}

export const activityLabel = {
  deposit: "Deposit",
  purchase: "Package purchase",
  daily_earning: "Daily earning",
  direct_commission: "Direct commission",
  level_commission: "Level commission",
  transfer_in: "Transfer in",
  transfer_out: "Transfer out",
  withdrawal: "Withdrawal",
  withdrawal_refund: "Withdrawal refund",
};

export async function api(path, { method = "GET", body, form, auth = true } = {}) {
  const headers = {};
  const token = auth ? getToken() : "";
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }

  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method,
      headers,
      body: form || (body !== undefined ? JSON.stringify(body) : undefined),
    });
  } catch {
    throw new ApiError(0, { message: "Cannot reach the server." });
  }

  const payload = await response.json().catch(() => ({}));
  if (response.status === 401 && token) {
    clearSession();
    if (!window.location.hash.startsWith("#/login")) window.location.hash = "#/login";
  }
  if (!response.ok || payload.success === false) throw new ApiError(response.status, payload);
  return payload;
}

// Public GETs: one network request per path per page load (shared by every caller),
// and the last response is kept so a return visit can render immediately.
const CACHE_PREFIX = "stravex_cache:";
const inflight = new Map();

export function peekCache(path) {
  try {
    const raw = window.localStorage.getItem(CACHE_PREFIX + path);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function cachedGet(path) {
  if (!inflight.has(path)) {
    const request = api(path, { auth: false }).then((payload) => {
      try {
        window.localStorage.setItem(CACHE_PREFIX + path, JSON.stringify(payload));
      } catch {
        // Storage full or blocked: the fresh response is still returned.
      }
      return payload;
    });
    request.catch(() => inflight.delete(path));
    inflight.set(path, request);
  }
  return inflight.get(path);
}
